import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px;
  text-align: center;
  min-width: 320px;
  max-width: 450px;
  box-sizing: border-box;
  
  @media (max-width: 640px) {
    padding: 24px 16px;
    min-width: unset;
    width: 100%;
  }
  
  @media (max-height: 700px) {
    padding: 20px 16px;
  }
`;

export const CheckIconContainer = styled.div`
  margin-bottom: 24px;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  background-color: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    color: white !important;
  }
  
  @media (max-height: 700px) {
    margin-bottom: 16px;
    width: 48px;
    height: 48px;
  }
`;

export const Title = styled.h2`
  margin: 0 0 24px 0;
  font-size: 28px;
  font-weight: 600;
  color: #333;
  
  @media (max-width: 640px) {
    font-size: 24px;
  }
  
  @media (max-height: 700px) {
    margin-bottom: 16px;
    font-size: 22px;
  }
`;

export const Message = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  font-weight: 400;
  color: #555;
  line-height: 1.6;
  
  @media (max-width: 640px) {
    font-size: 15px;
  }
  
  @media (max-height: 700px) {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const LinkSection = styled.div`
  margin: 0 0 24px 0;
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  width: 100%;
  
  @media (max-width: 640px) {
    font-size: 14px;
  }
  
  @media (max-height: 700px) {
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 1.4;
  }
`;

export const LinkIntro = styled.p`
  margin: 0 0 0.75rem 0;
  text-align: center;
`;

export const PublicUrl = styled.a`
  display: block;
  color: var(--primary-blue, #0B4598);
  text-decoration: none;
  word-break: break-all;
  font-weight: 500;
  padding: 0.75rem 1rem;
  background-color: var(--background-light, #f8f8f8);
  border-radius: 4px;
  margin: 0 0 0.75rem 0;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
    background-color: var(--background-lighter, #f0f0f0);
  }
  
  &:active {
    opacity: 0.8;
  }
`;

export const LinkOutro = styled.p`
  margin: 0;
  text-align: center;
  font-size: 0.9rem;
`;

export const TempingPromo = styled.div`
  margin: 0 0 32px 0;
  font-size: 16px;
  color: #555;
  line-height: 1.6;
  text-align: center;
  width: 100%;
  
  @media (max-width: 640px) {
    font-size: 15px;
    margin: 0 0 24px 0;
  }
  
  @media (max-height: 700px) {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.4;
  }
`;

export const BoldText = styled.span`
  font-weight: 600;
  color: var(--text-primary, #333);
`;

export const RNAPromoCard = styled.div`
  margin: 0 0 24px 0;
  padding: 16px 20px;
  background-color: #f5f8fc;
  border: 1px solid #dce4ef;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 640px) {
    padding: 14px 16px;
  }

  @media (max-height: 700px) {
    margin-bottom: 16px;
    padding: 12px 14px;
  }
`;

export const RNAPromoHeadline = styled.p`
  margin: 0 0 8px 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export const RNAPromoBody = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 400;
  color: #555;
  line-height: 1.5;

  strong {
    font-weight: 600;
  }

  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

export const RNAPromoLink = styled.a`
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-blue, #0B4598);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    opacity: 0.8;
  }

  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 280px;
`;

export const PostTempingButton = styled(Button)`
  &.MuiButton-root.MuiButton-contained {
    background-color: var(--success-main, #13CA82) !important;
    color: var(--common-white-main, #ffffff) !important;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    text-transform: none;
    border-radius: 6px;
    border: none !important;
    box-shadow: none !important;
    
    &:hover {
      background-color: #10B574 !important;
      box-shadow: none !important;
    }
    
    &:focus {
      background-color: var(--success-main, #13CA82) !important;
      box-shadow: none !important;
    }
    
    &:active {
      background-color: #0E9F6A !important;
      box-shadow: none !important;
    }
    
    &.Mui-disabled {
      background-color: #cccccc !important;
      color: #666666 !important;
    }
    
    @media (max-width: 640px) {
      font-size: 15px;
      padding: 10px 20px;
    }
  }
`;

export const CloseButton = styled(Button)`
  && {
    background-color: var(--primary-blue, #0B4598);
    color: var(--common-white-main, #ffffff);
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    border-radius: 6px;
    
    &:hover {
      background-color: var(--primary-blue-dark, #093b7f);
    }
    
    @media (max-width: 640px) {
      font-size: 15px;
      padding: 10px 20px;
    }
  }
`;
